module.exports = __webpack_public_path__ + "img/updateManage.83089ed5.svg";